// removed by extract-text-webpack-plugin
module.exports = {"hidden":"S0Z1P","visuallyhidden":"ZXMq2","hide-text":"_11LYr","center":"abC4h","error":"_1rs-x","overlayContainer":"qwCsP","overlayCountdown":"_226F5","overlayCloseButtonSymbol":"_2FXTu","noprint":"_2xtvA","root":"_2jO_0","player":"_3-4TT","overlayRoot":"_3EJMm","overlayBackgroundImage":"_1-1zE","overlayImageContainer":"_5Mjgo","overlayImageRatio":"_3ME-i","overlayImage":"Ls0XO","overlayPlayButton":"_2lWvf","overlayCountdownPath":"_iXqT","path":"_1112N","overlayTextContainer":"_2WE50","overlayLabel":"_2_ksX","overlayTitle":"_1g3c2","overlayCloseButton":"_2pMDk","svp-player-error-wrapper":"_3uPnI","svp-player-message":"_2_zfr"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/video-asset/styles/default.scss
 ** module id = 1029
 ** module chunks = 2
 **/